import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Llaves estables derivadas del contenido (para listas sin id); repetidos llevan #n.
export function keyed(items, fn) {
  const seen = {};
  return items.map((it) => { const k = String(fn(it)); seen[k] = (seen[k] || 0) + 1; return [seen[k] > 1 ? `${k}#${seen[k]}` : k, it]; });
}

export async function copyText(text) {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (e) { console.error("copyText: Clipboard API falló, usando respaldo", e?.name); }
  const ta = document.createElement("textarea");
  ta.value = text;
  ta.setAttribute("readonly", "");
  ta.style.position = "fixed";
  ta.style.opacity = "0";
  document.body.appendChild(ta);
  ta.select();
  ta.setSelectionRange(0, text.length);
  let ok = false;
  try { ok = document.execCommand("copy"); } catch { ok = false; }
  document.body.removeChild(ta);
  return ok;
}
